import React from 'react';
import {
  Drawer,
  DrawerBody,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  IconButton,
} from '@chakra-ui/react';
import { palette, Icon } from '@m12s/component-library';
import { falTimes } from 'lib/icons';

/**
 * A styled drawer component that matches the design system.
 * Slides up from the bottom with rounded corners, a header with close button,
 * and a body area for content.
 */
const MMDrawer = ({ isOpen, onClose, title, children }) => {
  return (
    <Drawer isOpen={isOpen} onClose={onClose} placement="bottom" size="full">
      <DrawerOverlay />
      <DrawerContent
        mt="0.5rem"
        borderTopRadius="0.375rem"
        maxH="calc(100vh - 0.5rem)"
      >
        <DrawerHeader
          color={palette.Grey700}
          borderBottom={`1px solid ${palette.Grey400}`}
          fontWeight="medium"
          position="relative"
        >
          {title}
          <IconButton
            onClick={onClose}
            aria-label="Close"
            icon={<Icon size="2rem" color={palette.Grey700} icon={falTimes} />}
            variant="ghost"
            position="absolute"
            top="50%"
            right="1.5rem"
            transform="translateY(-50%)"
            zIndex={1}
            bg="transparent"
            border={0}
            p={0}
            m={0}
            minW="auto"
            h="auto"
            _hover={{ bg: 'transparent' }}
            _focus={{ boxShadow: 'none' }}
            _focusVisible={{ boxShadow: 'none' }}
          />
        </DrawerHeader>
        <DrawerBody
          p={0}
          display="flex"
          flexDirection="column"
          position="relative"
        >
          {children}
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};

export default MMDrawer;
